import styles from "./food-number.module.less";

const FoodNumber = (props) => {
  return (
    <div className={[styles.wrapper, props.className].join(" ")}>
      <div className={styles.number}>{props.number}</div>
    </div>
  );
};

export default FoodNumber;
